import React from 'react'

import NewLayout from 'components/Layout/LayoutV1'
import { PreloadProvider } from 'context/PreloadContext'

import AlternativesLayout from './components/AlternativesLayout'

/** @type {import('./types').default} */
const Alternatives = ({ alternativesData }) => {
  return (
    <PreloadProvider>
      <AlternativesLayout {...alternativesData} />
    </PreloadProvider>
  )
}
Alternatives.Layout = NewLayout

export default Alternatives
